import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as PAYPERIOD_ACTIONS } from "../../../store/actions/payPeriodActions";
import HMRCLogo from "../../common/icons/hmrc.svg";
import Spinner from "../../common/Spinner";
import { toTitleCase } from "../../common/validation/Validators";

const FPSSubmissionStatus = ({ period, jurisdiction, getHMRCSubmissionStatus, userPermissions, openErrorsModal }) => {
	const { FPSStatus } = period;

	useEffect(() => {
		if (FPSStatus !== "pending") return; // if FPS status is not pending, do not check status
		const interval = setInterval(() => {
			if (FPSStatus !== "pending") clearInterval(interval);
			console.debug(`Getting HMRC Status For Period: ${period.id} - ${new Date().toISOString()}`);
			getHMRCSubmissionStatus(period.id);
		}, 15000); // Check Submission status every 15 seconds
		if (FPSStatus !== "pending") clearInterval(interval); // if updated, clear interval

		return () => clearInterval(interval); // if component unmounted, clear interval
	}, [FPSStatus]);

	if (userPermissions || !["UK"].includes(jurisdiction)) return null;

	return (
		<div
			title={FPSStatus ? toTitleCase(FPSStatus) : "Not Submitted"}
			style={{
				height: "1.5em",
				width: "1.5em",
				borderRadius: "50%",
				position: "relative",
				cursor: "pointer",
				marginLeft: 10,
			}}
		>
			<img
				src={HMRCLogo}
				style={{ height: "24.5px" }}
				onClick={() => {
					if (FPSStatus === "Failed") openErrorsModal(period);
				}}
			/>
			{FPSStatus === "Failed" && (
				<XCircleIcon
					style={{
						color: "red",
						height: "1.5rem",
						position: "absolute",
						right: -10,
						bottom: -10,
						background: "white",
						borderRadius: "4rem",
					}}
					className="-ml-1 mr-3"
					onClick={() => {
						openErrorsModal(period);
					}}
				/>
			)}
			{FPSStatus === "pending" && (
				<Spinner
					style={{
						color: "green",
						height: "1.5rem",
						position: "absolute",
						right: -10,
						bottom: -10,
					}}
					className="animate-spin -ml-1 mr-3"
				/>
			)}
			{FPSStatus === "Success" && (
				<CheckCircleIcon
					style={{
						color: "green",
						height: "1.5rem",
						position: "absolute",
						right: -9,
						bottom: -9,
						background: "white",
						borderRadius: "4rem",
					}}
				/>
			)}
		</div>
	);
};

const mapStateToProps = (state, { period }) => {
	const userPermissions = state?.permissions?.my?.permissions?.payroll == "Read";

	return {
		userPermissions,
		jurisdiction: state.company?.settings?.jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getHMRCSubmissionStatus: (periodId) => dispatch(PAYPERIOD_ACTIONS.getHMRCSubmissionStatus(periodId)),
	openErrorsModal: (period) => {
		dispatch(PAYPERIOD_ACTIONS.setHMRCErrorsModal({ open: true, period }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(FPSSubmissionStatus);
